import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { Injectable } from "@angular/core";

import { catchError, map } from "rxjs/operators";

import { environment } from "../environments/environment";
import { AuthenticationService } from "./shared/services/authService";
// import { HelperService } from './auth/_helpers/storage-helper';

@Injectable()
export class AppService {
  constructor(
    private http: HttpClient,
    private _router: Router,
    private _authService: AuthenticationService
  ) {}
  public _config = environment;
  public headerOptions = undefined;
  public url = this._config.serverIP;

  public get(_apiUrl): Observable<any> {
    return this.http
      .get(`${this.url}` + _apiUrl, this.header())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  getKeys() {
    if (sessionStorage.getItem("userKey") && sessionStorage.getItem("secretKey")) {
      return {
        userKey: sessionStorage.getItem("userKey"),
        secretKey: sessionStorage.getItem("secretKey"),
      };
    } else {
      return;
    }
  }

  // public setOptionsForHeader() {
  //   let keys = this.getKeys();
  //   if (keys && typeof keys == "object") {
  //     this._authService.HMACGeneration(keys.userKey, keys.secretKey).subscribe(
  //       (res) => {
  //         if (res.status == "ok") {
  //           this.headerOptions = {
  //             HMAC_Sign: res.HMAC_Sign,
  //             user_key: res.user_key,
  //             timeStamp: res.timeStamp,
  //           };
  //         }
  //       },
  //       (err) => {
  //         return undefined;
  //       }
  //     );
  //   }
  // }
  // public post(_apiUrl: string, apiArg: any, headers): Observable<any> {
  //     return this.http
  //       .post(
  //         `${this.url}` + _apiUrl,
  //         apiArg,
  //         this.setHeaders(this.headerOptions)
  //       )
  //       .pipe(map(this.extractData), catchError(this.handleError));
  // }

  public post_file(_apiUrl, item: any): Observable<any> {
    return this.http
      .post(`${this.url}` + _apiUrl, item.data, {
        headers: this.file_header(item),
        responseType: "text",
      })
      .pipe(map(this.FileextractData), catchError(this.handleError_));
  }

  public patch(_apiUrl: any, item: any): Observable<any> {
    return this.http
      .patch(`${this.url}` + _apiUrl, item, this._header())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public put(_apiUrl, itemId: number, item: any): Observable<any> {
    return this.http
      .put(`${this.url}` + _apiUrl + itemId, item.data, this._header(item))
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public put1(_apiUrl, item: any): Observable<any> {
    return this.http
      .put(`${this.url}` + _apiUrl, item.data, this._header(item))
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public delete(_apiUrl, item: any): Observable<any> {
    return this.http
      .delete(`${this.url}` + _apiUrl + item, this._header())
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  public FileextractData(res: any) {
    let body = res;
    return body;
  }
  public handleError_(error: Response | any) {
    return throwError(error);
  }

  getFromLocal(item) {
    return sessionStorage.getItem(item);
  }

  _header(hparam?) {
    let user = this.getFromLocal("currentUser_EPC_Portfolio");
    if (!!user) {
      let token = JSON.parse(user);
      // let token = temp['token'];
      const headers = new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "jwt " + token,
        Signature: hparam.hmac_sig,
        Key: hparam.u_key,
        Timestamp: hparam.timestamp,
      });
      const options = { headers: headers };
      return options;
    }
  }

  header() {
    let user = this.getFromLocal("currentUser_EPC_Portfolio");
    if (!!user) {
      let token = JSON.parse(user);
      const headers = new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "jwt " + token,
      });
      const options = { headers: headers };
      return options;
    }
  }

  // setHeaders(hmacData) {
  //   let user = this.getFromLocal("currentUser_EPC_Portfolio");
  //   if (!!user) {
  //     let token = JSON.parse(user);
  //     const headers = new HttpHeaders({
  //       "Content-Type": "application/json; charset=utf-8",
  //       Authorization: "jwt " + token,
  //       Signature: hmacData.HMAC_Sign,
  //       Key: hmacData.user_key,
  //       timestamp: hmacData.timeStamp,
  //       Pragma: "no-cache",
  //       "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
  //     });
  //     const options = { headers: headers };
  //     return options;
  //   }
  // }

  file_header(itm) {
    let user = this.getFromLocal("currentUser_EPC_Portfolio");
    if (!!user) {
      let token = JSON.parse(user);
      // let token = temp['token'];
      const headers = new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "jwt " + token,
        Signature: itm.hmac_sig,
        Key: itm.u_key,
        timestamp: itm.timestamp,
        Pragma: "no-cache",
        "Cache-Control": "no-cache, no-store, max-age=0, must-revalidate",
      });
      const options = headers;
      return options;
    }
  }

  public extractData(res: Response) {
    let body = res;
    return body;
  }
  public handleError(error: Response | any) {
    return throwError(error);
  }
}
